var map = {
	"./de-DE.json": [
		98406,
		8406
	],
	"./en-US.json": [
		71853,
		1853
	],
	"./fr-FR.json": [
		18968,
		8968
	],
	"./ja-JP.json": [
		51053,
		1053
	],
	"./pt-BR.json": [
		97379,
		9760
	],
	"./pt-PT.json": [
		4980,
		4980
	],
	"./ro-RO.json": [
		90302,
		302
	],
	"./zh-Hans-CN.json": [
		81822,
		1822
	],
	"./zh-Hant-TW.json": [
		68373,
		754
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67311;
module.exports = webpackAsyncContext;